'use client';

import { useTranslation } from 'react-i18next';
import { MenuConfig, MenuItem } from '@/config/types';
import { MegaMenuSubDefault } from './components';

/**
 * Multi-column mega panel used by the desktop header for items flagged
 * `isMegaPanel`. Expects a 2-level shape: the item passed in has
 * `children` of section items, each section has `children` of links.
 */
const MegaMenuSubApps = ({ items, title }: { items: MenuConfig; title?: string }) => {
  const { t } = useTranslation();

  const appsItem = title
    ? items.find((item) => item.title === title)
    : items.find((item) => item.title === 'Admin') ??
      items.find((item) => item.title === 'Settings') ??
      items.find((item) => item.title === 'Apps');

  if (!appsItem?.children) {
    return null;
  }

  return (
    <div className="w-full gap-0 lg:w-[720px]">
      <div className="pt-4 pb-2 lg:p-7.5">
        <div className="flex lg:gap-6">
          {appsItem.children.map((section: MenuItem, index) => (
            <div
              key={`mega-section-${index}`}
              className="flex flex-col grow min-w-[280px]"
            >
              <h3 className="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-4">
                {section.translationKey ? t(section.translationKey) : section.title}
              </h3>
              <div className="grow space-y-0.5 lg:grid lg:grid-cols-2 lg:gap-x-3 lg:gap-y-0.5 lg:space-y-0">
                {section.children && MegaMenuSubDefault(section.children)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { MegaMenuSubApps };
